import { createContext } from 'ui/lib/react-utils'
import { type AihubOffersContextState } from './types'

export const [AihubOffersProvider, useAiOffersContext] = createContext<AihubOffersContextState>({
  name: 'AiOffers'
})
